// extracted by mini-css-extract-plugin
export default {"flexContainer":"flexContainer--mj2PU"};